import axios from "axios";
import { getCookie } from "../../../App";
import { domain } from "../../Links/Links";
import { useContext } from "react";
import { AuthContext } from "../../SessionChecker/SessionChecker";

export async function addProductRequest( 
  name,
  price,
  priceType,
  caption,
  selectedHashtags,
  selectedImages,
  navigate,
  currentUserUsername,
) {

  const data = new FormData();

  data.append("name", name);

  data.append("price", price);
  data.append('price_type', priceType);
  data.append("caption", caption);
  selectedHashtags.forEach((hashtag) => {
    data.append("hashtags", hashtag);
  });

  selectedImages.forEach((image) => {
    data.append("images", image);
  });

  const response = await axios.post(domain + "/add_product/", data, {
    withCredentials: true,
    headers: {
      "X-CSRFToken": getCookie("csrf_token"),
    },
  });

  if (response.data.status == true) {
    navigate('/' + currentUserUsername)
  }
}
